import { setValue } from '../../lib/immutable_wrapper'
import {
    SET_LOCAL_AGENCY,
} from "./companiesConstants";

const initialState = {
    localAgency: null,
}

export function companies(state = initialState, action) {
    switch (action.type) {
        case SET_LOCAL_AGENCY:
            return setValue(state, ['localAgency'], action.localAgency);
        default:
            return state;
    }
}
